import PropTypes from 'prop-types'
import { reviewKeywordShape } from 'components/supplier_shared/ProsConsPills'

const socialShape = PropTypes.shape({
  platform: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired
})

export default PropTypes.shape({
  address: PropTypes.string,
  canEdit: PropTypes.bool,
  claimed: PropTypes.bool.isRequired,
  contactMethod: PropTypes.shape({
    contactConfigured: PropTypes.bool.isRequired,
    contactByEmail: PropTypes.bool,
    link: PropTypes.string
  }).isRequired,
  coverUrl: PropTypes.string,
  description: PropTypes.string,
  facebookUrl: PropTypes.string,
  id: PropTypes.number.isRequired,
  linkedinUrl: PropTypes.string,
  logoUrl: PropTypes.string,
  name: PropTypes.string.isRequired,
  phone: PropTypes.string,
  pro: PropTypes.bool.isRequired,
  rating: PropTypes.number.isRequired,
  reviewCount: PropTypes.number.isRequired,
  socialMedia: PropTypes.arrayOf(socialShape),
  reviewsSummary: PropTypes.string,
  reviewsSummaryLastUpdatedAt: PropTypes.string,
  reviewsKeywords: PropTypes.arrayOf(reviewKeywordShape.isRequired),
  website: PropTypes.string
})
